<template>
  <div class="min-h-screen flex flex-col">
    <Navbar />

    <main class="flex-1 max-w-4xl w-full mx-auto px-4 sm:px-6 lg:px-8 py-8">
      <Breadcrumbs :items="[{ label: 'Terms and Conditions' }]" />
      
      <div class="card mt-6">
        <div class="p-8 prose dark:prose-invert max-w-none">
          <h1 class="text-4xl font-bold text-gray-900 dark:text-gray-100 mb-6">
            Terms and Conditions
          </h1>
          
          <p class="text-sm text-gray-500 dark:text-gray-400 mb-8">
            Last updated: {{ new Date().toLocaleDateString() }}
          </p>

          <div class="space-y-6 text-gray-700 dark:text-gray-300">
            <section>
              <h2 class="text-2xl font-semibold text-gray-900 dark:text-gray-100 mb-4">1. Acceptance of Terms</h2>
              <p>
                By accessing and using the Neutral Fuels Customer Portal ("the Service"), you accept and agree to be bound by the terms and provision of this agreement.
              </p>
            </section>

            <section>
              <h2 class="text-2xl font-semibold text-gray-900 dark:text-gray-100 mb-4">2. Use License</h2>
              <p>
                Permission is granted to temporarily access the Service for personal, non-commercial transitory viewing only. This is the grant of a license, not a transfer of title.
              </p>
              <p class="mt-2">Under this license you may not:</p>
              <ul class="list-disc pl-6 mt-2 space-y-1">
                <li>Modify or copy the materials</li>
                <li>Use the materials for any commercial purpose</li>
                <li>Attempt to decompile or reverse engineer any software contained in the Service</li>
                <li>Remove any copyright or other proprietary notations from the materials</li>
                <li>Transfer the materials to another person or "mirror" the materials on any other server</li>
              </ul>
            </section>

            <section>
              <h2 class="text-2xl font-semibold text-gray-900 dark:text-gray-100 mb-4">3. Disclaimer</h2>
              <p>
                The materials on Neutral Fuels' Customer Portal are provided on an 'as is' basis. Neutral Fuels makes no warranties, expressed or implied, and hereby disclaims and negates all other warranties including, without limitation, implied warranties or conditions of merchantability, fitness for a particular purpose, or non-infringement of intellectual property or other violation of rights.
              </p>
            </section>

            <section>
              <h2 class="text-2xl font-semibold text-gray-900 dark:text-gray-100 mb-4">4. Limitations</h2>
              <p>
                In no event shall Neutral Fuels or its suppliers be liable for any damages (including, without limitation, damages for loss of data or profit, or due to business interruption) arising out of the use or inability to use the materials on Neutral Fuels' Customer Portal.
              </p>
            </section>

            <section>
              <h2 class="text-2xl font-semibold text-gray-900 dark:text-gray-100 mb-4">5. Accuracy of Materials</h2>
              <p>
                The materials appearing on Neutral Fuels' Customer Portal could include technical, typographical, or photographic errors. Neutral Fuels does not warrant that any of the materials on its website are accurate, complete or current.
              </p>
            </section>

            <section>
              <h2 class="text-2xl font-semibold text-gray-900 dark:text-gray-100 mb-4">6. Links</h2>
              <p>
                Neutral Fuels has not reviewed all of the sites linked to its Customer Portal and is not responsible for the contents of any such linked site.
              </p>
            </section>

            <section>
              <h2 class="text-2xl font-semibold text-gray-900 dark:text-gray-100 mb-4">7. Modifications</h2>
              <p>
                Neutral Fuels may revise these terms of service at any time without notice. By using this Service you are agreeing to be bound by the then current version of these terms of service.
              </p>
            </section>

            <section>
              <h2 class="text-2xl font-semibold text-gray-900 dark:text-gray-100 mb-4">8. Governing Law</h2>
              <p>
                These terms and conditions are governed by and construed in accordance with the laws of the United Arab Emirates and you irrevocably submit to the exclusive jurisdiction of the courts in that location.
              </p>
            </section>
          </div>

          <div class="mt-8 pt-6 border-t border-gray-200 dark:border-gray-700">
            <p class="text-sm text-gray-500 dark:text-gray-400">
              If you have any questions about these Terms and Conditions, please contact us at:
            </p>
            <p class="text-sm text-gray-700 dark:text-gray-300 mt-2">
              <strong>Email:</strong> support@neutralfuels.net<br />
              <strong>Phone:</strong> +971 4 234 5678
            </p>
          </div>
        </div>
      </div>
    </main>

    <Footer />
  </div>
</template>

<script setup>
import Navbar from '@/components/Navbar.vue'
import Footer from '@/components/Footer.vue'
import Breadcrumbs from '@/components/ui/Breadcrumbs.vue'
</script>
